import React from 'react';
import classNames from 'classnames';
import { T } from '@sm/intl';
import useSurveyStyles from './useStyles';

const DEFAULT_COPY = {
  TEXT: {
    id: 'ExitLink.Text',
    defaultMessage: 'Exit',
    description: '[Type: Link][Vis: med] - Exit link label',
  },
};

export type Props = { href: string; text?: string } & React.AllHTMLAttributes<HTMLAnchorElement>;

function ExitLink({ href, text, className }: Props): React.ReactElement {
  const { exitLink } = useSurveyStyles();
  return (
    <a href={href} className={classNames(exitLink, className)}>
      {text || <T desc={DEFAULT_COPY.TEXT} />}
    </a>
  );
}

export default ExitLink;
